import { useCentrixApi } from "core/hooks/useCentrixApi";
import { uuid } from "core/utils/uuid";
import type { PaymentRequestStatus } from "../entities/paymentRequestDefs";
import { usePaymentRequestId } from "./usePaymentRequestId";

export function usePaymentRequestStatusHistory(requestId?: string | string[]) {
  const paymentRequestId = usePaymentRequestId(requestId);
  const {
    data: statusData,
    mutate,
    isError,
    isLoading,
  } = useCentrixApi({
    path: "/api/app/payment-request-status-history",
    parameters: { query: { PaymentRequestId: paymentRequestId } },
  });
  const { items, totalCount } = statusData || {};

  function addLocalStatusHistoryEntry(status: PaymentRequestStatus) {
    const statusHistoryEntry = {
      creationTime: new Date().toUTCString(),
      id: uuid(),
      paymentRequestId,
      status,
    };
    mutate((data) => {
      const currentItems = data?.items || [];
      const newItems = [...currentItems, statusHistoryEntry];
      return { items: newItems, totalCount: newItems.length };
    }, false);
  }

  return {
    items,
    totalCount,
    mutate,
    isError,
    isLoading,
    addLocalStatusHistoryEntry,
  };
}
